import type { ReactNode } from 'react';

import type { ToastOptions, TypeOptions } from 'react-toastify/unstyled';
import { toast } from 'react-toastify/unstyled';

interface NotifyProps extends ToastOptions {
  type?: TypeOptions | 'default';
  title: string;
  description?: ReactNode;
}

export const notify = ({ type = 'info', title, description, ...options }: NotifyProps) => {
  const toastMethod = type !== 'default' && toast[type] ? toast[type] : toast;

  return toastMethod(
    <button
      type="button"
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation();
        }
      }}
      className="flex flex-col gap-0.5 w-full text-left bg-transparent border-none p-0 outline-none cursor-default"
    >
      <b className="block text-[15px] font-medium leading-[1.2] text-foreground mb-1">{title}</b>
      {description && (
        <div className="text-[14px] leading-snug opacity-90 text-muted-foreground wrap-break-word">{description}</div>
      )}
    </button>,
    {
      ...options,
    },
  );
};
